<!-- One cell for the field and its button: the button, `relative`, paints over the folding field.
 `ml-auto` pushes it and what follows it against the profile; on a phone its margins put the glyph 16px from its neighbors. -->
<ng-template #searchToggle>
  <span
    class="grid items-center"
    [class]="
      searchFillsBar() ? 'min-w-0 flex-1' : 'ml-auto shrink-0 not-expanded:-ml-2 not-expanded:mr-1'
    ">
    @if (searchOpen()) {
      <!-- `search-opening` grows it from the button's width; `search-folding` marks the leave.
       A phone or reduced motion shows and hides it at once: a zero duration, not `transition-none`, or the leave waits it out. -->
      <mib-search-field
        class="col-start-1 row-start-1 overflow-hidden transition-[width] duration-300 ease-in-out motion-reduce:duration-0 starting:[&.search-opening]:w-9 [&.search-folding]:pointer-events-none [&.search-folding]:w-9 not-expanded:duration-0"
        animate.leave="search-folding"
        [class]="searchFillsBar() ? 'w-full' : 'w-64'"
        [class.search-opening]="searchOpenedByButton()"
        clearLabel="Clear the search"
        (focusout)="foldSearch($event)">
        <input
          #searchInput
          type="search"
          class="mib-input"
          placeholder="Search case title, summary"
          aria-label="Search the cases"
          [formField]="searchForm" />
      </mib-search-field>
    } @else {
      @let searchApplied = library.trimmedSearch() !== '';
      <button
        mibButton
        type="button"
        theme="secondary"
        mode="ghost"
        activeTone="primary"
        class="relative col-start-1 row-start-1"
        mibTooltip="Search the cases"
        [size]="headerControlSize()"
        [active]="searchApplied"
        [attr.aria-label]="
          searchApplied ? 'Search cases: ' + library.trimmedSearch() : 'Search the cases'
        "
        (click)="openSearch()">
        <svg mib-icon name="search"></svg>
      </button>
    }
  </span>
</ng-template>

<ng-template maiHeaderMiddle [fillsBar]="searchFillsBar()">
  <!-- A phone leads with the search; moved in the DOM, not by `order`, so focus follows the eye. -->
  @if (notExpanded()) {
    <ng-container [ngTemplateOutlet]="searchToggle"></ng-container>
  }
  <!-- Hidden, not removed, under the full-bar search: the live button keeps its rooms and pending start. -->
  <span [class]="searchFillsBar() ? 'hidden' : 'contents'">
    <!-- Uploading belongs to the application, not to one card, so it sits in the bar. -->
    @if (permissions.canUploadCase()) {
      <!-- `secondary` filled, not `outlined`: its hover is `gray-100`, not `gray-700`. -->
      <button
        mibButton
        type="button"
        theme="secondary"
        class="shrink-0 whitespace-nowrap"
        aria-label="Upload video"
        [size]="headerControlSize()"
        (click)="pickVideo()">
        <svg mib-icon name="upload"></svg>
        @if (!notExpanded()) {
          Upload video
        }
      </button>
    }
    <!-- Hides itself when the organization has no room, so the bar is unchanged without one. -->
    <mai-new-live-button [size]="headerControlSize()"></mai-new-live-button>
  </span>
  @if (!notExpanded()) {
    <ng-container [ngTemplateOutlet]="searchToggle"></ng-container>
  }
  <span [class]="searchFillsBar() ? 'hidden' : 'contents'">
    <!--
     The same group at every size. On the phone layout the zones are stacked, so it navigates between
     them one at a time; elsewhere it shows and hides the two columns independently.
    -->
    <mib-button-toggles
      aria-label="Displayed zones"
      [size]="headerControlSize()"
      [multiple]="!compact()"
      [segments]="zoneSegments"
      [value]="zoneGroupValue()"
      (valueChange)="setVisibleZones($event)"></mib-button-toggles>
  </span>
</ng-template>

<mai-library-zones
  [zones]="visibleZones()"
  [mobileZone]="mobileZone()"
  [chatOnRow]="chatOnRow()"
  [(filtersOpen)]="filtersOpen"></mai-library-zones>
